(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vowhound-halloween-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  function setupHalloween() {
    if (!document.getElementById('vh-halloween-motion')) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const host = entry.target;
        const rect = host.getBoundingClientRect();
        const horizontal = Math.min(rect.width * .24, 110);
        host.style.setProperty('--ha-left', -horizontal + 'px');
        host.style.setProperty('--ha-right', horizontal + 'px');
        host.style.setProperty('--ha-upper', Math.round(rect.height * .16) + 'px');
        host.style.setProperty('--ha-middle', Math.round(rect.height * .35) + 'px');
        host.style.setProperty('--ha-lower', Math.round(rect.height * .55) + 'px');
        if (!reduce.matches) host.classList.add('vh-ha-play');
        observer.unobserve(host);
      }
    }, {threshold:.25});
    const mount = (host, atmosphere) => {
      if (!host || host.querySelector(':scope > .vh-ha-layer')) return;
      host.classList.add('vh-ha-host');
      if (!atmosphere) host.classList.add('vh-ha-shirt');
      const layer = document.createElement('span');
      layer.className = 'vh-ha-layer';
      layer.setAttribute('aria-hidden','true');
      if (atmosphere) {
        const moon = document.createElement('span');
        moon.className = 'vh-ha-moon';
        layer.append(moon);
        const fog = document.createElement('span');
        fog.className = 'vh-ha-fog';
        layer.append(fog);
      }
      for (let i=0;i<3;i++) {
        const bat = document.createElement('span');
        bat.className = 'vh-ha-bat';
        bat.dataset.haBat = String(i);
        bat.innerHTML = '<svg viewBox="0 0 64 34" focusable="false" aria-hidden="true"><path d="M32 14L27 7L27 15C19 10 11 5 2 3C5 12 6 20 5 26C12 21 17 22 21 28C26 25 29 28 32 32C35 28 38 25 43 28C47 22 52 21 59 26C58 20 59 12 62 3C53 5 45 10 37 15L37 7Z"/></svg>';
        layer.append(bat);
      }
      host.append(layer);
      observer.observe(host);
    };
    const title = main.querySelector('h1');
    title?.classList.add('vh-ha-title');
    mount(main.querySelector('.vh-top-hero') || title?.closest('.shopify-section'), true);
    const images = Array.from(main.querySelectorAll('a[href*="/products/"] img'));
    const targets = new Set();
    for (const img of images) {
      const link = img.closest('a');
      if (!link || targets.has(link) || /phone.case/i.test(img.alt + ' ' + link.href)) continue;
      if (targets.size >= 4) break;
      targets.add(link);
      mount(link,false);
    }
    reduce.addEventListener('change', () => {
      if (reduce.matches) main.querySelectorAll('.vh-ha-play').forEach(el=>el.classList.remove('vh-ha-play'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setupHalloween,{once:true});
  else setupHalloween();
  document.addEventListener('shopify:section:load',setupHalloween);
})();
  } catch(e) { console.error(e); }
})();

})();
